import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const Container = styled.div `
  width: 33%;
  min-height: 310px;
  height: auto;
  padding: 15px;
  padding-right: 0px;

  ${breakpoints.phone} {
    width: 100%;
    padding-left: 0px;
  }

  .card-converter {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: stretch;
    background-color: ${Color.greyF5F5F5};
    padding: 20px;
    gap: 10px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      background-color: ${ColorDark.darkGrey};
      }
    }

    .title-converter {
      ${Font.sansBold}
      font-size: 14px;
      line-height: 24px;
      color: ${Color.black000};
      text-transform: uppercase;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color: ${ColorDark.textLight};
        }
      }
      @media (min-width: 976px) and (max-width: 1360px) {

        font-size: 12px;

      }

    }
    input {
      ${Font.sansRegular}
      font-size: 18px;
      line-height: 20px;
      color: ${Color.black000};
      height: 35px;
      padding-left: 10px;
      border: 1px solid ${Color.greySeparator};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        background:  ${ColorDark.backDarknew};
        border:none;
        color: ${ColorDark.textLight};
        }
      }
    }

    .options {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .op-1,
      .op-2 {
        border: 1px solid ${Color.greySeparator};
        width: 130px;
        height: 35px;
        ${breakpoints.darkMode} {
         
      [data-theme='dark'] & {
          border:none;
      }
        }
      
        ${breakpoints.phone} {
          width: 150px;
        }
      }

      select {
        ${Font.sansRegular}
        font-size: 13px;
        line-height: 20px;
        color: ${Color.black000};
        height: 33px;
        width: 100%;
        border: none;
        background-color: ${Color.white};
        padding: 5px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
        background-repeat: no-repeat;
        background-position-x: 100%;
        background-position-y: 5px;
        padding: 0 25px 0 10px !important;
        -webkit-padding-end: 25px !important;
        -webkit-padding-start: 10px !important;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          background-color: ${ColorDark.backDarknew};
          color: ${ColorDark.textLight};
          border:none;
          background-image: url("data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
          }
        }

        :focus-visible {
          outline-color: ${Color.mainColor};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            outline-color: ${ColorDark.greySeparator};
            }

  
          }
        }
      }
    }

    button {
      background-color: ${Color.mainColor};
      border-radius: 50px;
      width: 100%;
      height: 35px;
      ${Font.sansRegular}
      font-size: 16px;
      line-height: 20px;
      color: ${Color.white};
      border: none;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        background-color: ${ColorDark.mainColor};
        }


      }
      :hover {
        background-color: #bd0019;
        cursor: pointer;
      }
    }

    .calculation-cointainer {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      background-color: ${Color.white};
      margin-top: 10px;
      padding: 10px;
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        background-color: ${ColorDark.greySeparator};
        }
        
      }

      .result {
        ${Font.sansRegular}
        font-size: 22px;
        line-height: 20px;
        color: ${Color.mainColor};
        margin-bottom: 10px;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color: ${ColorDark.mainColor};
  
          }
        }

        @media (min-width: 976px) and (max-width: 1360px) {

          font-size: 20px;
        }
      }
      .parameters {
        ${Font.sansRegular}
        font-size: 14px;
        line-height: 20px;
        color: ${Color.grey};
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color: ${ColorDark.textLight};
  
          }
        }
      }
    }
  }
`;